import { render, staticRenderFns } from "./VueltaCamion.vue?vue&type=template&id=a009dcc2&"
import script from "./VueltaCamion.vue?vue&type=script&lang=js&"
export * from "./VueltaCamion.vue?vue&type=script&lang=js&"
import style0 from "./VueltaCamion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports